import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FilterDefinition} from "../../../model/CourseFilters";
import {AuthorizationServiceProvider} from "../../../auth_profile/services/authorization-service.provider";
import {forkJoin, switchMap, tap} from "rxjs";
import { CourseFilterComponent } from 'src/app/utils/course-filter/course-filter.component';
import {LangProductMapper} from "../../utils/lang-mappers";
import * as LessonsV3 from '../../model/v3/lessons';
import {SpinnerService} from "../../../utils/services/spinner.service";
import {NativeServiceApiProvider} from "../../../services/native-api-provider.service";

@Component({
    selector: 'app-courses-page',
    templateUrl: './courses-page.component.html',
    styleUrls: ['./courses-page.component.scss'],
    standalone: false
})
export class CoursesPageComponent implements OnInit, AfterViewInit {

  chosenCourse: FilterDefinition;
  CourseFilterComponent = CourseFilterComponent;
  supportedLangs: string[] = [];
  langs: LessonsV3.V3Product[];

  private studentId: number;
  private schoolId: number;

  constructor(
    private authService: AuthorizationServiceProvider,
    private provider: NativeServiceApiProvider,
    private spinner: SpinnerService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.langs = LangProductMapper.getCourseProducts();
    this.spinner.trace(
      this.authService.getAuthDetailsService().pipe(
        switchMap((api) => forkJoin({
          studentId: api.getSelfStudentId(),
          schoolId: api.getSelfSchoolId(),
        })),
        tap(({studentId, schoolId}) => {
          this.studentId = studentId;
          this.schoolId = schoolId;
        }),
        switchMap(() => this.provider.colV3()),
        switchMap((api) =>
          forkJoin(
            this.langs.map((lang) =>
              api.getProductContexts(this.schoolId, this.studentId, lang.code)
            )
          )
        ),
        tap((contextsByLang) => {
          this.supportedLangs = this.langs
            .filter((_, i) => !!contextsByLang[i]?.length)
            .map((lang) => lang.code);
        })
      )
    ).subscribe();
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  isLangSupported(lang: string) {
    return this.supportedLangs.includes(lang);
  }
}
